/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatExportItemDto } from './ChatExportItemDto';
import {
    ChatExportItemDtoFromJSON,
    ChatExportItemDtoFromJSONTyped,
    ChatExportItemDtoToJSON,
    ChatExportItemDtoToJSONTyped,
} from './ChatExportItemDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ChatExportListResponseDto
 */
export interface ChatExportListResponseDto {
    /**
     * 
     * @type {Array<ChatExportItemDto>}
     * @memberof ChatExportListResponseDto
     */
    data: Array<ChatExportItemDto>;
    /**
     * 
     * @type {PaginationDto}
     * @memberof ChatExportListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the ChatExportListResponseDto interface.
 */
export function instanceOfChatExportListResponseDto(value: object): value is ChatExportListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ChatExportListResponseDtoFromJSON(json: any): ChatExportListResponseDto {
    return ChatExportListResponseDtoFromJSONTyped(json, false);
}

export function ChatExportListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatExportListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ChatExportItemDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function ChatExportListResponseDtoToJSON(json: any): ChatExportListResponseDto {
    return ChatExportListResponseDtoToJSONTyped(json, false);
}

export function ChatExportListResponseDtoToJSONTyped(value?: ChatExportListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ChatExportItemDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

